var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOctopus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.391,
    x2: 366.807,
    xlinkHref: "#lg1",
    y1: 79.224,
    y2: 396.873
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.671,
    x2: 204.063,
    xlinkHref: "#lg2",
    y1: 179.394,
    y2: 194.786
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.757,
    x2: 309.149,
    xlinkHref: "#lg2",
    y1: 179.394,
    y2: 194.786
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(.943 -.332 .332 .943 -111.029 -272.999)",
    gradientUnits: "userSpaceOnUse",
    x1: 53.653,
    x2: 85.228,
    xlinkHref: "#lg1",
    y1: 518.194,
    y2: 549.768
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.393,
    x2: 373.66,
    xlinkHref: "#lg1",
    y1: 195.474,
    y2: 235.938
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.375,
    x2: 203.825,
    y1: 245.639,
    y2: 351.836
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa9b1"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -22.397,
    x2: 177.747,
    xlinkHref: "#lg3",
    y1: 125.118,
    y2: 325.262
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(.742 -.671 .671 .742 -333.067 -599.114)",
    gradientUnits: "userSpaceOnUse",
    x1: -209.703,
    x2: -201.035,
    xlinkHref: "#lg3",
    y1: 755.828,
    y2: 764.496
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(.742 -.671 .671 .742 -333.067 -599.114)",
    gradientUnits: "userSpaceOnUse",
    x1: -209.069,
    x2: -200.402,
    xlinkHref: "#lg3",
    y1: 789.817,
    y2: 798.485
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(.832 .555 -.555 .832 -95.908 655.996)",
    gradientUnits: "userSpaceOnUse",
    x1: -161.213,
    x2: -152.546,
    xlinkHref: "#lg3",
    y1: -496.194,
    y2: -487.527
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(.95 .312 -.312 .95 -11.865 389.624)",
    gradientUnits: "userSpaceOnUse",
    x1: -26.892,
    x2: -18.225,
    xlinkHref: "#lg3",
    y1: -197.983,
    y2: -189.316
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(.986 -.165 .165 .986 -65.195 -102.706)",
    gradientUnits: "userSpaceOnUse",
    x1: 27.299,
    x2: 35.967,
    xlinkHref: "#lg3",
    y1: 351.96,
    y2: 360.628
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(.785 -.619 .619 .785 -374.112 -512.662)",
    gradientUnits: "userSpaceOnUse",
    x1: -173.239,
    x2: -164.572,
    xlinkHref: "#lg3",
    y1: 875.981,
    y2: 884.648
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(.511 -.86 .86 .511 -716.103 -677.266)",
    gradientUnits: "userSpaceOnUse",
    x1: -455.888,
    x2: -447.221,
    xlinkHref: "#lg3",
    y1: 1179.419,
    y2: 1188.086
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(.128 -.992 .992 .128 -1140.248 -684.183)",
    gradientUnits: "userSpaceOnUse",
    x1: -853.987,
    x2: -845.32,
    xlinkHref: "#lg3",
    y1: 1374.08,
    y2: 1382.747
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(-1 0 0 1 -1869.481 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -2401.878,
    x2: -2201.734,
    xlinkHref: "#lg3",
    y1: 125.118,
    y2: 325.262
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(-.742 -.671 -.671 .742 -1536.414 -599.114)",
    gradientUnits: "userSpaceOnUse",
    x1: -1974.548,
    x2: -1965.881,
    xlinkHref: "#lg3",
    y1: -840.182,
    y2: -831.515
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(-.742 -.671 -.671 .742 -1536.414 -599.114)",
    gradientUnits: "userSpaceOnUse",
    x1: -1973.915,
    x2: -1965.248,
    xlinkHref: "#lg3",
    y1: -806.193,
    y2: -797.526
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(-.832 .555 .555 .832 -1773.573 655.996)",
    gradientUnits: "userSpaceOnUse",
    x1: -2141.412,
    x2: -2132.744,
    xlinkHref: "#lg3",
    y1: 823.177,
    y2: 831.845
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(-.95 .312 .312 .95 -1857.616 389.624)",
    gradientUnits: "userSpaceOnUse",
    x1: -2287.462,
    x2: -2278.795,
    xlinkHref: "#lg3",
    y1: 544.817,
    y2: 553.484
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(-.986 -.165 -.165 .986 -1804.286 -102.706)",
    gradientUnits: "userSpaceOnUse",
    x1: -2319.495,
    x2: -2310.828,
    xlinkHref: "#lg3",
    y1: -41.086,
    y2: -32.419
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(-.785 -.619 -.619 .785 -1495.369 -512.662)",
    gradientUnits: "userSpaceOnUse",
    x1: -2041.893,
    x2: -2033.226,
    xlinkHref: "#lg3",
    y1: -597.132,
    y2: -588.465
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientTransform: "matrix(-.511 -.86 -.86 .511 -1153.378 -677.266)",
    gradientUnits: "userSpaceOnUse",
    x1: -1671.031,
    x2: -1662.364,
    xlinkHref: "#lg3",
    y1: -866.395,
    y2: -857.728
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(-.128 -.992 -.992 .128 -729.232 -684.183)",
    gradientUnits: "userSpaceOnUse",
    x1: -1158.432,
    x2: -1149.765,
    xlinkHref: "#lg3",
    y1: -985.844,
    y2: -977.177
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.438,
    x2: 118.102,
    xlinkHref: "#lg3",
    y1: 358.609,
    y2: 420.433
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientTransform: "matrix(.756 -.655 .655 .756 -401.791 -519.256)",
    gradientUnits: "userSpaceOnUse",
    x1: -271.608,
    x2: -262.94,
    xlinkHref: "#lg3",
    y1: 932.041,
    y2: 940.708
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientTransform: "matrix(.567 -.824 .824 .567 -653.553 -644.927)",
    gradientUnits: "userSpaceOnUse",
    x1: -468.693,
    x2: -460.026,
    xlinkHref: "#lg3",
    y1: 1154.143,
    y2: 1162.81
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientTransform: "matrix(.236 -.972 .972 .236 -1055.643 -691.378)",
    gradientUnits: "userSpaceOnUse",
    x1: -811.318,
    x2: -802.65,
    xlinkHref: "#lg3",
    y1: 1357.624,
    y2: 1366.291
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientTransform: "matrix(-.106 -.994 .994 -.106 -1426.696 -590.414)",
    gradientUnits: "userSpaceOnUse",
    x1: -1170.633,
    x2: -1161.966,
    xlinkHref: "#lg3",
    y1: 1429.921,
    y2: 1438.588
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientTransform: "matrix(-.483 -.876 .876 -.483 -1770.971 -301.563)",
    gradientUnits: "userSpaceOnUse",
    x1: -1559.368,
    x2: -1550.701,
    xlinkHref: "#lg3",
    y1: 1353.398,
    y2: 1362.065
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientTransform: "matrix(-1 0 0 1 -1869.481 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -2279.043,
    x2: -2261.379,
    xlinkHref: "#lg3",
    y1: 358.609,
    y2: 420.433
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientTransform: "matrix(-.756 -.655 -.655 .756 -1467.689 -519.256)",
    gradientUnits: "userSpaceOnUse",
    x1: -2069.335,
    x2: -2060.668,
    xlinkHref: "#lg3",
    y1: -626.838,
    y2: -618.171
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientTransform: "matrix(-.567 -.824 -.824 .567 -1215.928 -644.927)",
    gradientUnits: "userSpaceOnUse",
    x1: -1816.982,
    x2: -1808.315,
    xlinkHref: "#lg3",
    y1: -806.481,
    y2: -797.813
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientTransform: "matrix(-.236 -.972 -.972 .236 -813.838 -691.378)",
    gradientUnits: "userSpaceOnUse",
    x1: -1373.111,
    x2: -1364.444,
    xlinkHref: "#lg3",
    y1: -954.587,
    y2: -945.919
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientTransform: "matrix(.106 -.994 -.994 -.106 -442.784 -590.414)",
    gradientUnits: "userSpaceOnUse",
    x1: -918.198,
    x2: -909.531,
    xlinkHref: "#lg3",
    y1: -936.132,
    y2: -927.465
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientTransform: "matrix(.483 -.876 -.876 -.483 -98.51 -301.563)",
    gradientUnits: "userSpaceOnUse",
    x1: -410.204,
    x2: -401.537,
    xlinkHref: "#lg3",
    y1: -730.193,
    y2: -721.526
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.748,
    x2: 338.252,
    xlinkHref: "#lg3",
    y1: 408.773,
    y2: 575.276
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientTransform: "matrix(-.838 -.546 .546 -.838 -1900.033 337.804)",
    gradientUnits: "userSpaceOnUse",
    x1: -1844.883,
    x2: -1836.216,
    xlinkHref: "#lg3",
    y1: 1075.106,
    y2: 1083.773
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientTransform: "matrix(-.693 -.721 .721 -.693 -1844.001 104.017)",
    gradientUnits: "userSpaceOnUse",
    x1: -1687.037,
    x2: -1678.369,
    xlinkHref: "#lg3",
    y1: 1220.193,
    y2: 1228.861
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientTransform: "matrix(-.339 -.941 .941 -.339 -1600.674 -250.001)",
    gradientUnits: "userSpaceOnUse",
    x1: -1300.476,
    x2: -1291.809,
    xlinkHref: "#lg3",
    y1: 1408.835,
    y2: 1417.502
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientTransform: "matrix(-.175 -.985 .985 -.175 -1463.207 -346.365)",
    gradientUnits: "userSpaceOnUse",
    x1: -1117.881,
    x2: -1109.213,
    xlinkHref: "#lg3",
    y1: 1409.806,
    y2: 1418.473
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientTransform: "matrix(.838 -.546 -.546 -.838 30.552 337.804)",
    gradientUnits: "userSpaceOnUse",
    x1: 148.674,
    x2: 157.341,
    xlinkHref: "#lg3",
    y1: -224.344,
    y2: -215.677
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientTransform: "matrix(.693 -.721 -.721 -.693 -25.48 104.017)",
    gradientUnits: "userSpaceOnUse",
    x1: -37.801,
    x2: -29.134,
    xlinkHref: "#lg3",
    y1: -495.284,
    y2: -486.617
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientTransform: "matrix(.339 -.941 -.941 -.339 -268.807 -250.001)",
    gradientUnits: "userSpaceOnUse",
    x1: -494.851,
    x2: -486.183,
    xlinkHref: "#lg3",
    y1: -830.319,
    y2: -821.652
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientTransform: "matrix(.175 -.985 -.985 -.175 -406.274 -346.365)",
    gradientUnits: "userSpaceOnUse",
    x1: -702.365,
    x2: -693.698,
    xlinkHref: "#lg3",
    y1: -933.309,
    y2: -924.642
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m497.715 314.601c-12.746-8.58-30.032-5.205-38.614 7.539-17.321 25.725-39.246 39.893-61.734 39.893-19.001 0-37.598-10.114-53.357-28.766 7.479 1.301 15.112 1.975 22.847 1.975 37.819 0 73.247-15.848 99.756-44.624 14.72-15.977 22.826-37.066 22.826-59.382 0-22.37-8.146-43.507-22.934-59.5-10.954-11.846-10.823-31.384.108-43.251l25.078-27.222c10.41-11.3 9.688-28.899-1.611-39.31-11.301-10.41-28.9-9.69-39.31 1.611l-25.078 27.222c-14.72 15.978-22.826 37.067-22.826 59.382 0 22.316 8.106 43.405 22.826 59.383 10.828 11.754 10.828 31.614 0 43.367-15.852 17.207-36.746 26.683-58.835 26.683-.26 0-.52-.001-.78-.004-21.508-.218-31.788-26.588-16.198-41.406 27.836-26.457 44.621-64.429 42.713-106.285-3.319-72.812-63.71-130.776-136.596-131.29-76.527-.54-138.732 61.333-138.732 137.734 0 39.21 16.386 74.591 42.683 99.673 15.648 14.926 5.602 41.356-16.022 41.575-.26.003-.519.004-.779.004-22.089 0-42.983-9.476-58.835-26.683-10.828-11.753-10.828-31.613 0-43.367 14.719-15.978 22.826-37.067 22.826-59.383 0-22.315-8.106-43.404-22.826-59.382l-24.689-26.798c-10.27-11.148-27.693-12.519-39.118-2.558-11.855 10.335-12.78 28.341-2.194 39.832l25.078 27.222c10.828 11.754 10.828 31.614 0 43.368-14.72 15.978-22.826 37.067-22.826 59.382 0 22.316 8.107 43.405 22.826 59.382 26.51 28.776 61.936 44.624 99.756 44.624 7.735 0 15.368-.674 22.847-1.975-15.759 18.652-34.356 28.766-53.357 28.766-22.489 0-44.414-14.168-61.735-39.893-8.582-12.746-25.87-16.121-38.614-7.538-12.745 8.581-16.12 25.868-7.538 38.613 13.734 20.397 30.019 36.353 48.401 47.424 18.765 11.302 38.779 17.033 59.487 17.033s40.722-5.731 59.487-17.033c7.029-4.233 13.749-9.187 20.139-14.824-5.525 13.051-14.004 25.062-25.127 35.332-16.306 15.055-38.997 23.729-62.318 23.837-13.398.062-25.247 9.212-27.743 22.375-3.365 17.754 10.157 33.265 27.303 33.265 37.851 0 73.542-13.707 100.501-38.598 15.957-14.733 28.529-32.327 37.141-51.485 5.033-11.197 20.932-11.197 25.965 0 8.611 19.157 21.184 36.751 37.141 51.485 26.805 24.748 62.244 38.441 99.854 38.596 15.337.063 28.262-12.107 28.464-27.443.205-15.536-12.328-28.195-27.817-28.195-23.475 0-46.35-8.689-62.758-23.837-11.123-10.27-19.602-22.281-25.127-35.333 6.391 5.637 13.111 10.591 20.14 14.824 18.764 11.302 38.779 17.033 59.487 17.033 20.707 0 40.722-5.731 59.486-17.033 18.383-11.07 34.668-27.026 48.402-47.424 8.58-12.743 5.204-30.03-7.54-38.612z",
    fill: "url(#SVGID_1_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 202.457,
    cy: 193.18,
    fill: "url(#SVGID_2_)",
    r: 19.082
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.543,
    cy: 193.18,
    fill: "url(#SVGID_3_)",
    r: 19.082
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m168.972 254.551c-22.982 8.089-48.17-3.984-56.26-26.966s3.984-48.17 26.966-56.26 52.276 75.136 29.294 83.226z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.028 254.551c22.982 8.089 48.17-3.984 56.26-26.966 8.089-22.982-3.984-48.17-26.966-56.26s-52.276 75.136-29.294 83.226z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m305.124 462.026c26.805 24.749 62.245 38.441 99.854 38.596 15.336.063 28.262-12.107 28.464-27.443.205-15.536-12.328-28.195-27.817-28.195-23.475 0-46.35-8.689-62.758-23.837-11.123-10.27-19.602-22.281-25.127-35.333 6.391 5.637 13.111 10.591 20.14 14.824 18.764 11.302 38.779 17.033 59.487 17.033 20.707 0 40.722-5.731 59.486-17.033 18.383-11.07 34.668-27.026 48.402-47.424 8.581-12.745 5.205-30.032-7.539-38.614-12.746-8.58-30.032-5.205-38.614 7.539-17.321 25.725-39.246 39.893-61.734 39.893-19.001 0-37.598-10.114-53.357-28.766 7.479 1.301 15.112 1.975 22.847 1.975 37.819 0 73.247-15.848 99.756-44.624 14.72-15.977 20.826-37.066 20.826-59.382 0-22.37-6.146-43.507-20.934-59.5-10.954-11.846-10.823-31.384.108-43.251l25.078-27.222c10.41-11.3 9.688-28.899-1.611-39.31-11.301-10.41-28.9-9.69-39.31 1.611l-25.078 27.222c-14.72 15.978-22.826 37.067-22.826 59.382 0 22.316 8.106 43.405 22.826 59.383 10.828 11.754 10.828 31.614 0 43.367-15.852 17.207-36.746 26.683-58.835 26.683-.26 0-.52-.001-.779-.004-21.624-.219-31.67-26.649-16.022-41.575 26.297-25.082 42.683-60.463 42.683-99.673-.002-76.068-61.67-137.736-137.74-137.736v345.39c0 42.777 16.88 84.077 47.701 113.74.799.77 1.606 1.531 2.423 2.284z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m165.304 321.217c-.002 0 .002 0 0 0-37.82 0-73.247-15.848-99.756-44.624-14.719-15.977-22.826-37.066-22.826-59.382 0-22.315 8.106-43.404 22.826-59.382 10.828-11.754 10.828-31.614 0-43.368l-25.078-27.223c-.807-.876-1.665-1.811-2.555-2.785-11.545-12.622-31.162 4.103-20.197 17.231.3.359.609.711.928 1.058l24.647 26.754c10.828 11.754 7.828 31.614-3 43.368-14.72 15.978-19.826 37.067-19.826 59.382 0 22.316 8.107 43.405 22.826 59.382 26.51 28.776 61.936 44.624 99.756 44.624h.001c8.197 0 16.282-.745 24.187-2.206 7.772-1.436 6.641-12.871-1.261-12.832-.225.002-.449.003-.672.003z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m38.88 110.372c-4.96 4.486-12.618 4.101-17.104-.859s-4.101-12.618.859-17.104 21.205 13.477 16.245 17.963z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.147 135.157c-4.96 4.486-12.618 4.101-17.104-.859s-4.101-12.618.859-17.104 21.205 13.477 16.245 17.963z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.107 175.587c-5.566-3.708-7.071-11.226-3.363-16.792s11.226-7.071 16.792-3.363-7.863 23.863-13.429 20.155z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.396 215.045c-6.354-2.088-9.812-8.931-7.724-15.285s8.931-9.812 15.285-7.724-1.207 25.096-7.561 23.009z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.709 257.909c-6.596 1.105-12.839-3.347-13.944-9.943s3.347-12.839 9.943-13.944 10.597 22.782 4.001 23.887z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.066 292.119c-5.252 4.14-12.866 3.239-17.007-2.013s-3.239-12.866 2.013-17.007c5.252-4.14 20.246 14.88 14.994 19.02z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.154 318.809c-3.415 5.75-10.846 7.643-16.596 4.227s-7.643-10.846-4.227-16.596c3.416-5.749 24.239 6.619 20.823 12.369z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.223 331.523c-.856 6.633-6.926 11.316-13.56 10.461-6.633-.856-11.316-6.926-10.461-13.56.857-6.632 24.877-3.534 24.021 3.099z",
    fill: "url(#SVGID_15_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m344.696 321.217c37.82 0 73.247-15.848 99.756-44.624 14.719-15.977 22.826-37.066 22.826-59.382 0-22.315-8.106-43.404-22.826-59.382-10.828-11.754-10.828-31.614 0-43.368l25.078-27.222c.807-.876 1.665-1.811 2.555-2.785 11.545-12.622 31.163 4.103 20.197 17.231-.3.359-.609.711-.928 1.058l-24.647 26.754c-10.828 11.754-7.828 31.614 3 43.368 14.72 15.978 19.826 37.067 19.826 59.382 0 22.316-8.107 43.405-22.826 59.382-26.51 28.776-61.936 44.624-99.756 44.624-.002 0 .001 0-.001 0-8.197 0-16.282-.745-24.187-2.206-7.772-1.436-6.641-12.871 1.261-12.832.225.001.449.002.672.002z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m471.12 110.372c4.96 4.486 12.618 4.101 17.104-.859s4.101-12.618-.859-17.104-21.205 13.477-16.245 17.963z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447.853 135.157c4.96 4.486 12.618 4.101 17.104-.859s4.101-12.618-.859-17.104-21.205 13.477-16.245 17.963z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467.893 175.587c5.566-3.708 7.071-11.226 3.363-16.792s-11.226-7.071-16.792-3.363 7.863 23.863 13.429 20.155z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482.604 215.045c6.354-2.088 9.812-8.931 7.724-15.285s-8.931-9.812-15.285-7.724c-6.353 2.087 1.207 25.096 7.561 23.009z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m477.291 257.909c6.596 1.105 12.839-3.347 13.944-9.943s-3.347-12.839-9.943-13.944-10.597 22.782-4.001 23.887z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.934 292.119c5.252 4.14 12.866 3.239 17.007-2.013 4.14-5.252 3.239-12.866-2.013-17.007-5.252-4.14-20.246 14.88-14.994 19.02z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.846 318.809c3.415 5.75 10.846 7.643 16.596 4.227 5.75-3.415 7.643-10.846 4.227-16.596-3.416-5.749-24.239 6.619-20.823 12.369z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.777 331.523c.856 6.633 6.927 11.316 13.56 10.461 6.633-.856 11.316-6.926 10.461-13.56-.857-6.632-24.877-3.534-24.021 3.099z",
    fill: "url(#SVGID_24_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m198.148 366.831c-1.25 6.866-3.154 12.54-5.888 18.984-6.383 5.645-13.207 11.604-20.238 15.832-18.766 11.3-38.775 17.036-59.483 17.036s-40.718-5.736-59.483-17.036c-18.391-11.067-34.668-27.02-48.406-47.425-2.448-3.632-3.925-7.638-4.481-11.715-.961-6.97 7.891-10.723 12.21-5.159.03.04.061.071.081.101 11.967 15.316 25.584 27.617 40.596 36.651 18.766 11.3 38.775 17.036 59.483 17.036s40.718-5.736 59.483-17.036c5.987-3.603 11.749-7.724 17.273-12.349 3.889-3.256 9.762.089 8.853 5.08z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.959 371.515c-5.053 4.382-12.701 3.837-17.082-1.216-4.382-5.053-3.837-12.701 1.216-17.082s20.919 13.917 15.866 18.298z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.718 398.511c-3.79 5.511-11.329 6.906-16.84 3.116s-6.906-11.329-3.116-16.84c3.789-5.51 23.745 8.213 19.956 13.724z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.647 412.809c-1.579 6.499-8.127 10.487-14.626 8.908s-10.487-8.127-8.908-14.626 25.113-.781 23.534 5.718z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.078 410.169c.71 6.65-4.106 12.616-10.757 13.326-6.65.71-12.616-4.106-13.326-10.757-.71-6.65 23.373-9.219 24.083-2.569z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.945 392.192c3.23 5.856 1.101 13.222-4.755 16.452s-13.222 1.101-16.452-4.755c-3.231-5.857 17.977-17.554 21.207-11.697z",
    fill: "url(#SVGID_30_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m311.852 366.831c1.25 6.866 3.154 12.54 5.887 18.984 6.383 5.645 13.208 11.604 20.239 15.833 18.766 11.3 38.775 17.036 59.483 17.036s40.718-5.736 59.483-17.036c18.391-11.067 34.668-27.02 48.406-47.425 2.448-3.632 3.925-7.638 4.481-11.715.961-6.97-7.891-10.723-12.21-5.159-.03.04-.061.071-.081.101-11.967 15.316-25.584 27.617-40.596 36.651-18.766 11.3-38.775 17.036-59.483 17.036s-40.718-5.736-59.483-17.036c-5.987-3.603-11.749-7.724-17.273-12.349-3.889-3.257-9.762.088-8.853 5.079z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.041 371.515c5.053 4.382 12.701 3.837 17.082-1.216 4.382-5.053 3.837-12.701-1.216-17.082-5.052-4.381-20.919 13.917-15.866 18.298z",
    fill: "url(#SVGID_32_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.282 398.511c3.79 5.511 11.329 6.906 16.84 3.116s6.906-11.329 3.116-16.84c-3.789-5.51-23.745 8.213-19.956 13.724z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.353 412.809c1.579 6.499 8.128 10.487 14.626 8.908 6.499-1.579 10.487-8.127 8.908-14.626-1.578-6.499-25.113-.781-23.534 5.718z",
    fill: "url(#SVGID_34_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.922 410.169c-.71 6.65 4.106 12.616 10.757 13.326 6.65.71 12.616-4.106 13.326-10.757.71-6.65-23.373-9.219-24.083-2.569z",
    fill: "url(#SVGID_35_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.055 392.192c-3.23 5.856-1.101 13.222 4.755 16.452s13.222 1.101 16.452-4.755c3.231-5.857-17.977-17.554-21.207-11.697z",
    fill: "url(#SVGID_36_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m407.017 482.294c-.436.021-.869.032-1.296.032-37.851 0-73.542-13.707-100.501-38.598-12.288-11.346-22.557-24.392-30.561-38.54-4.02-7.106-11.493-11.554-19.658-11.554-8.164 0-15.638 4.448-19.658 11.554-8.004 14.148-18.273 27.194-30.561 38.54-26.959 24.89-62.651 38.598-100.501 38.598-.427 0-.86-.011-1.296-.032-12.464-.598-14.285 17.75-1.887 19.162 1.045.119 2.107.18 3.183.18 37.851 0 73.542-13.707 100.501-38.598 15.7-14.496 28.124-31.762 36.721-50.561 5.251-11.482 21.744-11.482 26.995 0 8.598 18.799 21.021 36.065 36.721 50.561 26.959 24.89 62.651 38.598 100.501 38.598 1.076 0 2.139-.061 3.183-.18 12.399-1.413 10.578-19.76-1.886-19.162z",
    fill: "url(#SVGID_37_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m235.314 422.621c5.603 3.652 7.184 11.155 3.532 16.757s-11.155 7.184-16.757 3.532c-5.603-3.652 7.623-23.941 13.225-20.289z",
    fill: "url(#SVGID_38_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.434 453.764c4.635 4.821 4.484 12.487-.337 17.122s-12.487 4.484-17.122-.337c-4.636-4.821 12.823-21.606 17.459-16.785z",
    fill: "url(#SVGID_39_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.657 480.881c2.264 6.293-1.002 13.23-7.295 15.494s-13.23-1.002-15.494-7.295c-2.265-6.292 20.525-14.492 22.789-8.199z",
    fill: "url(#SVGID_40_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.01 495.161c1.168 6.585-3.224 12.87-9.809 14.038s-12.87-3.224-14.038-9.809c-1.169-6.585 22.679-10.814 23.847-4.229z",
    fill: "url(#SVGID_41_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.878 422.621c-5.603 3.652-7.184 11.155-3.532 16.757 3.652 5.603 11.155 7.184 16.757 3.532 5.603-3.652-7.623-23.941-13.225-20.289z",
    fill: "url(#SVGID_42_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.758 453.764c-4.635 4.821-4.484 12.487.337 17.122s12.487 4.484 17.122-.337c4.636-4.821-12.823-21.606-17.459-16.785z",
    fill: "url(#SVGID_43_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.535 480.881c-2.264 6.293 1.002 13.23 7.295 15.494s13.23-1.002 15.494-7.295c2.265-6.292-20.525-14.492-22.789-8.199z",
    fill: "url(#SVGID_44_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.182 495.161c-1.168 6.585 3.224 12.87 9.809 14.038s12.87-3.224 14.038-9.809-22.679-10.814-23.847-4.229z",
    fill: "url(#SVGID_45_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOctopus);
export default __webpack_public_path__ + "static/media/icon-octopus.2269d1e3877af59268cf37e94958ae41.svg";
export { ForwardRef as ReactComponent };